
    <!-- [class]="options?.htmlClass || ''"-->
    <div [class.floatLabelContainer]="true">
      <label *ngIf="options?.title"
        [attr.for]="'control' + layoutNode?._id"
        [class]="options?.labelHtmlClass || ''"
        [style.display]="options?.notitle ? 'none' : ''"
        [innerHTML]="options?.title"></label>
      <input float-label
        [formControl]="formControl"
        [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
        [attr.list]="'control' + layoutNode?._id + 'Autocomplete'"
        [attr.placeholder]="options?.placeholder"
        [attr.dateFormat]="options?.dateFormat"
        [attr.required]="options?.required"
        [class]="options?.fieldHtmlClass || ''"
        [disabled]="controlDisabled"
        [id]="'control' + layoutNode?._id"
        [name]="controlName"
        [readonly]="options?.readonly ? 'readonly' : null"
        [type]="layoutNode?.type"
        (input)="onDateInput($event)" 
        (dateTimeChange)="onDateInput($event)" 
        [owlDateTime]="dt3" [maxlength]="appConfig?.dateFormat?.length || 11" DateFormat>
        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" [startAt]="startDateTime" #dt3></owl-date-time>
        <span class="input-group-addon date-format" [owlDateTimeTrigger]="dt3">
            <span class="fa fa-calendar select-pointer" attr.aria-label="{{'common.Set current date'|translate|translateKey}}"
        tabindex="0"></span>
        </span>
        <!-- Email verification spinner block start -->
        <span *ngIf="layoutNode?.name==='email' && isShowLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Email verification spinner block end -->
    </div>
    <span *ngIf="customMessage && !isShowLoader" [class]="'error custom-error'">{{customMessage}}</span>


// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-datepicker.widget.ts.CustomDatePickerComponent.html